/** Same rules as account site_name / server eventSlug. */
const EVENT_SLUG_REGEX = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

export function slugifyEventName(name) {
  const s = String(name || '')
    .trim()
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 63)
    .replace(/-+$/g, '');
  return s;
}

/**
 * @param {unknown} value
 * @returns {{ valid: boolean, message?: string }}
 */
export function validateEventSlug(value) {
  if (value === undefined || value === null) return { valid: false, message: 'URL slug is required' };
  const s = String(value).trim().toLowerCase();
  if (s.length === 0) return { valid: false, message: 'URL slug is required' };
  if (s.length < 2) return { valid: false, message: 'URL slug must be at least 2 characters' };
  if (s.length > 63) return { valid: false, message: 'URL slug must not exceed 63 characters' };
  if (!EVENT_SLUG_REGEX.test(s)) {
    return {
      valid: false,
      message: 'URL slug may only contain lowercase letters, numbers, and hyphens (cannot start or end with a hyphen)',
    };
  }
  return { valid: true };
}

export { EVENT_SLUG_REGEX };
